import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { StorageTypeKey } from '../enums/StorageTypeKey';
import { guidUtil } from '../../utils/guidUtil.functions';
@Injectable({
  providedIn: 'root',
})
export class ClientGuidService {
  constructor(private authService: AuthService) {}

  async _createAndStore() {
    const newClientGuid = guidUtil.generate();
    await this.authService.setClientGuid(newClientGuid);
    return newClientGuid;
  }
  async getOrCreate(): Promise<string> {
    try {
      const result = this.authService.getClientGuid();
      if (result) return result;
      return this._createAndStore();
    } catch (_) {
      return this._createAndStore();
    }
  }
}
